/**
 * @generated SignedSource<<73af2c3d142ae500b06283c45988dec7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientClass = "CUSTOMER" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type ClubStackNavigatorFragment_session$data = {
  readonly currentClientProfile: {
    readonly id?: string;
    readonly member: {
      readonly clientClass: ClientClass | null | undefined;
      readonly club: {
        readonly slug: string;
      };
    } | null | undefined;
    readonly onboardedAt?: string | null | undefined;
  } | null | undefined;
  readonly user: {
    readonly __typename: string;
    readonly email: string | null | undefined;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ClubSwitcherFragment_memberUser">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ClubSwitcherFragment_session" | "HomeTabsNavigator_session" | "LessonFacilitySwitcherModalFragment_session" | "MasqueradeBarPatronFragment_session" | "useCurrentClubHasLessonsEnabled_session">;
  readonly " $fragmentType": "ClubStackNavigatorFragment_session";
};
export type ClubStackNavigatorFragment_session$key = {
  readonly " $data"?: ClubStackNavigatorFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubStackNavigatorFragment_session">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubStackNavigatorFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClubSwitcherFragment_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomeTabsNavigator_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonFacilitySwitcherModalFragment_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MasqueradeBarPatronFragment_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCurrentClubHasLessonsEnabled_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ClubSwitcherFragment_memberUser"
            }
          ],
          "type": "MemberUser",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clientClass",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "onboardedAt",
              "storageKey": null
            }
          ],
          "type": "MemberProfile",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "2f2d60a4b213c21c033568ace72f90b8";

export default node;
